import React from 'react';
import _ from 'lodash';

import DDadosBase, { LabeledInput } from '@common/components/ddados/ddados.base';

import Field from '@common/components/validation/field.validation';
import { DateTimePicker } from '@progress/kendo-react-dateinputs';
import DateFormat from '@common/components/formats/date.format';

import { OverlayTrigger, Tooltip as TooltipBootstrap, FormGroup } from 'react-bootstrap';

class DDadosComponent extends DDadosBase {
  constructor(props) {
    super(props);
  }

  validate(value) {
    const { DataFutura } = this;

    const dataAtual = new Date();

    if(!value?.getFullYear)
      return;

    if (value.getFullYear() < 1753) return 'O ano deve ser maior que 1752.';
    if (!DataFutura && value > dataAtual) return 'A data não deve ser maior que a data atual.';
  }

  async validateOnBlur(name, label, value) {
    if (value && value != '__/__/____ __:__:__') {
      if (value.includes('_')) {
        var inputDate = document.querySelector(`input[name=${name}]`);
        const result = await _alert.warningPromise(`O valor do campo ${label} é inválido.`, 'Data e Hora inválida.');
        if (result) {
          inputDate.focus();
        }
      }
    }
  }

  renderComponent() {
    const { props, validate } = this;
    const { Label, Tooltip, Obrigatorio, Desabilitado, name, validateOnBlur, PlacementTooltip } = props;
    return (
      <Field {...props} validate={validate}>
        {({ value, hasError, onChangeAsync, onBlur }) => {
          return (
            <LabeledInput {...props}>
              <OverlayTrigger
                key={`top-${name}`}
                placement={PlacementTooltip || 'top'}
                overlay={
                  <TooltipBootstrap id={`tooltip-${name}`}>
                    <div className={'fontTooltip'}>{Tooltip || Label}</div>
                  </TooltipBootstrap>
                }
              >
                <div>
                  <DateTimePicker
                    className={`${hasError ? 'span-input-invalid' : ''}`}
                    format={'dd/MM/yyyy HH:mm:ss'}
                    formatPlaceholder={{ year: '____', month: '__', day: '__', hour: '__', minute: '__', second: '__' }}
                    name={name}
                    validityStyles={false}
                    disabled={Desabilitado}
                    required={Obrigatorio}
                    value={value && new Date(value)}
                    onChange={onChangeAsync}
                    onBlur={(event) => {
                      validateOnBlur && this.validateOnBlur(name, Label, event.target.value);
                      onBlur();
                    }}
                  />
                </div>
              </OverlayTrigger>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderView() {
    return (
      <Field {...this.props}>
        {(field) => {
          return (
            <LabeledInput {...this.props} Obrigatorio={false}>
              <span>
                <label className='form-control' readOnly>
                  <DateFormat value={field.value} onlyDate={false} />
                </label>
              </span>
            </LabeledInput>
          );
        }}
      </Field>
    );
  }

  renderHeader() {
    return (
      <div>
        <Field {...this.props}>
          {(field) => {
            return (
              <label style={{ fontWeight: 'bold' }}>
                {this.props.Label}
                <label>
                  <DateFormat value={field.value} onlyDate={false} />
                </label>
              </label>
            );
          }}
        </Field>
      </div>
    );
  }
}

export default DDadosComponent;
